<template>
  <qz-results-details
    :quote="quote"
    :is-view-monthly="isViewMonthly"
    :is-buy-online-disabled="isBuyOnlineDisabled"
    :details-description="detailsDescription"
    :selected-optional-extras="selectedOptionalExtras"
    :is-details-drawer-open="isDetailsDrawerOpen"
    :product-name="productName"
    :filter-extras="filterExtras"
    :good-to-know-options="['covered', 'notAvailable']"
    :is-info-note-shown="false"
    :quote-position-number="quotePositionNumber"
    @go-to-form="$emit('go-to-form')"
    @close-drawer="$emit('close-drawer')"
    @open-drawer-details="$emit('open-drawer-details', ['details-description', 'estimatedPrice'])"
  />
</template>

<script>
import QzResultsDetails from '@/components/QzResults/QzResultsDetails';
import { isEmpty } from 'lodash';

export default {
  name: 'results-details',
  components: {
    QzResultsDetails,
  },
  props: {
    quote: {
      required: false,
      type: Object,
      default: undefined,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    detailsDescription: {
      type: Object,
      required: true,
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
    isDetailsDrawerOpen: {
      type: Boolean,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    quotePositionNumber: {
      required: true,
      type: Number,
    },
    optionalExtraValues: {
      type: Array,
      default: null,
    },
  },
  data () {
    return {
      buyOnlineChecked: false,
    };
  },
  computed: {
    quoteDetails () {
      return this.quote?.details?.[0] || null;
    },
    hasBuyOnline () {
      return this.quoteDetails?.isBuyOnlineCheckbox;
    },
    isBuyOnlineDisabled () {
      return (!this.buyOnlineChecked && this.hasBuyOnline);
    },
  },
  methods: {
    filterExtras (condition) {
      const accumulator = this.optionalExtraValues.reduce((acc, extra) => {
        if (
          (condition === 'Y' && this.quoteDetails[extra]) ||
          (condition === 'N' && !this.quoteDetails[extra])
        ) {
          return {
            ...acc,
            [extra]: extra,
          };
        }
        return acc;
      }, {});
      return isEmpty(accumulator) ? null : accumulator;
    },
  },
};
</script>
